module.exports = __webpack_public_path__ + "img/fullscreen.c8f0a5c.svg";